;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export type RentvineVendorOption = {
	label: string;
	value: string;
};

function getRecord(value: unknown): Record<string, unknown> | null {
	return typeof value === "object" && value !== null
		? (value as Record<string, unknown>)
		: null;
}

function isActiveRentvineContact(contact: Record<string, unknown>): boolean {
	if (!("isActive" in contact)) {
		return true;
	}

	const isActiveValue = contact.isActive;
	return isActiveValue === "1" || isActiveValue === 1 || isActiveValue === true;
}

export function toRentvineVendorOption(
	vendor: unknown,
): RentvineVendorOption | null {
	const vendorRecord = getRecord(vendor);
	if (!vendorRecord) {
		return null;
	}

	const contactRecord = getRecord(vendorRecord.contact) ?? vendorRecord;
	if (!isActiveRentvineContact(contactRecord)) {
		return null;
	}

	const contactIdRaw = contactRecord.contactID ?? contactRecord.contactId;
	const contactId =
		typeof contactIdRaw === "string" || typeof contactIdRaw === "number"
			? String(contactIdRaw).trim()
			: "";
	if (contactId.length === 0) {
		return null;
	}

	const nameRaw = contactRecord.name;
	const label =
		typeof nameRaw === "string" && nameRaw.trim().length > 0
			? nameRaw.trim()
			: contactId;

	return {
		label,
		value: contactId,
	};
}

export function toRentvineVendorOptions(
	vendors: unknown[],
): RentvineVendorOption[] {
	return Array.from(
		new Map(
			vendors
				.map(toRentvineVendorOption)
				.filter((vendorOption): vendorOption is RentvineVendorOption =>
					Boolean(vendorOption),
				)
				.map((vendorOption) => [vendorOption.value, vendorOption]),
		).values(),
	).sort((vendorOptionA, vendorOptionB) =>
		vendorOptionA.label.localeCompare(vendorOptionB.label),
	);
}

export function mergeRentvineVendorOptions({
	liveVendorOptions,
	savedContactIds,
}: {
	liveVendorOptions: RentvineVendorOption[];
	savedContactIds: string[];
}): RentvineVendorOption[] {
	const savedVendorOptions = savedContactIds
		.map((contactId) => contactId.trim())
		.filter((contactId) => contactId.length > 0)
		.map((contactId) => ({
			label: `Vendor ${contactId}`,
			value: contactId,
		}));

	// Live options come last so named labels win over saved ID fallbacks.
	return Array.from(
		new Map(
			[...savedVendorOptions, ...liveVendorOptions].map((option) => [
				option.value,
				option,
			]),
		).values(),
	).sort((optionA, optionB) => optionA.label.localeCompare(optionB.label));
}
